module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABa0lEQVRoQ+2ZPU7EMBCFP296frJLQZYtQYIrUHMNboDooKGjATrEDTgHNUeAgnI3uwUkWuiDERIFUqREnmiiyJrUnvf83nNix+OI5HGR6MCEDC1JS8QSUXKgtrRWjE89/gHYUOLsCvvlcGe7FI//gWpClqQfwLgrm3J9kVFO2oS8AIfKE+kK/5pRHjUKmbOzn1BdAJtd2ZTqPyuSuxnvb41ClMjVYW0fUbc4kMASCTRMfbglom5xIIElEmiY+nBLRN3iQIJaIjnpicPfgNsKxOppuF97RpdTiqe20+8c2OtpVlKaRUY5axSyIs09ZFKGnuraheRsHzu4HvIfosddTSmf7Rjf07IR0dg+IrJNscgSUTRXBG2JiGxTLLJEFM0VQVsiItsUi2qJLJgcjPj+vfsdbFuhIrltvftdksZxGx9Nf+SvY3UPDPRXl7XDnbd2rBTfR1Vo+/yq2isAt0QEpqmWWCKq9grAo0nkB3fzQzPF2enXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rem/nav.png
// module id = ytBc
// module chunks = 14